export const FirebaseConfig = {
	"projectId": "taxi-thestudiomax",
	"appId": "1:214790576340:web:da69e1e9c77fdf83744341",
	"databaseURL": "https://taxi-thestudiomax-default-rtdb.firebaseio.com",
	"storageBucket": "taxi-thestudiomax.firebasestorage.app",
	"locationId": "us-central1",
	"apiKey": "AIzaSyA7zM7mp_j6h9bxqcPI0ul7vYIcJzR6xbE",
	"authDomain": "taxi-thestudiomax.firebaseapp.com",
	"messagingSenderId": "214790576340",
	"measurementId": "",
	"projectNumber": "214790576340",
	"version": "2"
};
